import apiService from 'v2/services/api';
import type { ApiService } from 'v2/services/api';

class Transfer {
  constructor(private apiServices: ApiService) {}

  public getAvailable = () => this.apiServices.get('financial-statement/balance/available');
}

export const transferService = new Transfer(apiService);
